import queryString from 'query-string';
import React, { lazy, useContext, useEffect, useMemo, useState } from 'react';
// Cookies Library
import { useCookies } from 'react-cookie';
import { useTranslation } from 'react-i18next';
// Redux
import { useDispatch, useSelector } from 'react-redux';
// Router
import { useHistory, useParams, useRouteMatch } from 'react-router-dom';
import { menuTrack } from '../../analytics/tracker/events/menuEvents';
import { orderTypeTrack } from '../../analytics/tracker/events/orderTypeEvents';
import '../../css/cart.css';
import '../../css/home.css';
// Importing Css Files
import '../../css/menu.css';
// Functions Import
import { getCountryCode } from '../../functions/getCountryCode';
import { getCartBillFunction, getCartFunction } from '../../redux/cart/cartActions';
import { setOrderType } from '../../redux/orderType/orderTypeActions';
import { fetchRestSetting } from '../../redux/RestSetting/restSettingActions';
import {
  DELIVERY_TYPE,
  DINEIN_TYPE,
  LITE,
  LITE_DEL,
  MENU,
  PRO,
  SCHEDULED,
} from '../../webStorage/keys/sessionKeys';
import {
  getLocalItem,
  getUserToken,
  removeLocalItem,
  setLocalItem,
} from '../../webStorage/localStorage';
import {
  getOrderType,
  getOrderTypeSession,
  getRestaurantType,
  initializeOrderTypeInfo,
  removeCurrnetMall,
  setOrderTypeSession,
  getTableId,
} from '../../webStorage/manageOrderType';
import {
  getSessionItem,
  setBackPage,
  setBackPath,
  setHistoryArray,
  getHistoryArray,
  setMenuPath,
  setSessionItem,
  removeSessionItem,
} from '../../webStorage/sessionStorage';
import { updateCartDetails } from '../cart/cartHtpp/trackOrderType';
import LocationPopupImporter from '../common/locationPopupImporter';
import RouterContex from '../FoodCourt/Context/RouterContext';
import MenuCategoryContext from './context/categoryContext';
import { SCROLL } from './dictionary/scrollevents';
import Discount from './discount';
import Footer from './footer';
import { fbPixelNoScriptText, fbPixelScriptText } from './Functions/fbPixel';
import NormalRestaurantHead from './header/normalRestaurantHead';
// Importing Components
import MenuItems from './menuItems';
import OrderType from './orderType';
import Promotion from './promotion';
import isLoyaltyShowing from '../../functions/isLoyaltyShowing';
import GlobalContext from '../../GlobalContext';
import { getPromotions } from './Functions/promotionHttp';
import RestaurantClosed from '../popUp/ScheduledOrder/RestaurantClosed';
import AppLoader from '../common/loaders/App-loader';
import SuspenseWrapper from '../common/suspenseWrapper';
import Skeleton from '../common/loaders/skeleton';
import { fetchReferrerCode } from '../../functions/referral/fetchReferrerCode';
import { fetchReferralInfo } from '../../functions/referral/fetchReferralInfo';
import { setCheckCartToken, getCartTokenLS } from '../../functions/getCartToken';
import {
  cookiesCartTokenTrack,
  setCookieTableInfoTrack,
  setOrderSessionTrack,
} from '../../analytics/tracker/events/bugTrack';
import { checkIfAlreadyRunningDineInOrder } from '../../functions/checkIfAlreadyRunningDineInOrder';
import { axiosInstanceNext, axiosInstance } from '../../axios/axios';
import { GET_CART, USER_TABLE_CHANGE } from '../../axios/appiendPoints';
const ExitPagePopup = lazy(() =>
  import(/* webpackChunkName:"ExitPagePopup"*/ '../popUp/exitPagePopup')
);
const DiscountAppliedPopUp = lazy(() =>
  import(/* webpackChunkName:"DiscountAppliedPopUp"*/ '../popUp/discountAppliedPopUp')
);
const QuickServicesPopup = lazy(() =>
  import(/* webpackChunkName:"QuickServicesPopup"*/ '../popUp/quickServicesPopup')
);
const TableChangePopUp = lazy(() =>
  import(/* webpackChunkName:"table-change-popup" */ '../popUp/TableChange/tableChangePopUp')
);
const ChangeLanguagePopup = lazy(() =>
  import(/* webpackChunkName:"ChangeLanguagePopup"*/ '../popUp/changeLanguagePopup')
);

function Menu() {
  const validateLoyaltyOrderTypes = {
    0: 'DINEIN',
    1: 'DLEV',
    2: 'TAKEAYPICKUP',
  };
  const history = useHistory();
  const urlParams = useParams();
  const hasPromotionShowen = getSessionItem(urlParams.name);
  const userId = getLocalItem('user_id');
  const { url } = useRouteMatch();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { setRoute } = useContext(RouterContex);
  const [cookies, setCookie] = useCookies(['cart_token']);
  const [categoryId, setCategoryId] = useState(0);
  const [eventType, setEventType] = useState(SCROLL);
  const [drawer, setDrawer] = useState(false);
  const [showChangeLanguage, setShowChangeLanguage] = useState(false);
  const [waitingForPromotions, setWaitingForPromotions] = useState(true);
  const [referrerCode, setReferrerCode] = useState({});
  const [referralInfo, setReferralInfo] = useState({});
  const [promotions, setPromotions] = useState([]);
  const [showMenu, setShowMenu] = useState(
    (!promotions?.length && !waitingForPromotions) || !!hasPromotionShowen
  );
  const [showExitPagePopup, setShowExitPagePopup] = useState(false);
  const [cartDispatchCount, setCartDispatchCount] = useState(0);
  // const cartTokenFromLS = getCartTokenLS();
  const cartTokenFromLSUseEffectDep = getCartTokenLS();

  // Fetching Values from redux
  const cartFromRedux = useSelector((state) => state.cart.cart);
  const cartLoadedFromRedux = useSelector((state) => state.cart.loaded);
  const cartBillFromRedux = useSelector((state) => state.cart.cartBill);
  const fbPixelId = useSelector(
    (state) => state.restSetting?.Setting?.settings?.marketing?.fb_pixel
  );
  const restaurantDetails = useSelector((state) => state.restSetting);
  const plan = useSelector((state) => state.restSetting?.Setting?.settings?.global?.plan);
  const restarantIdFromRedux = useSelector((state) => state.restSetting?.Setting?.id);
  const restarantSettingFromRedux = useSelector((state) => state.restSetting?.Setting);
  const userDetails = useSelector((state) => state.userDetails?.Details?.data);
  const userTokenFromRedux = userDetails?.token;
  const urlQuery = queryString.parse(window.location.search);

  const [coupon, setCoupon] = useState('');
  const [couponApplied, setCouponApplied] = useState(false);
  const [freeDeliveryCoupon, setFreeDeliveryCoupon] = useState(null);
  const [showOrderTypePopup, setShowOrderTypePopup] = useState(false);
  const [previousOrders, setPreviousOrders] = useState([]);
  const [couponCode, setcouponCode] = useState('NOCODE');
  const [showPopup, setShowPopup] = useState(false);
  const [popUpOpened, setPopUpOpened] = useState(false);
  const historyArray = getHistoryArray();
  removeLocalItem('ot');
  const orderTypeAndTime = useSelector((state) => state.orderTypeOrderTime);
  const countryCode = getCountryCode();

  let orderType = getOrderType();
  const isLoaded = restarantSettingFromRedux && restarantSettingFromRedux?.nameid;
  const FCHeader = useMemo(
    () =>
      urlParams.mall && lazy(() => import(/* webpackChunkName:"FCHeader"*/ '../FoodCourt/Header')),
    []
  );
  !urlParams?.mall && removeCurrnetMall();
  const getOrderTypeDetails = (ot) => {
    const serviceTimings = restarantSettingFromRedux?.serviceable?.service_timing;
    const serviceableStrings = [
      { type: 'dine_in', string: 'is_dn_serviceable' },
      { type: 'delivery', string: 'is_dl_serviceable' },
      { type: 'pickup', string: 'is_ta_serviceable' },
    ];
    const isRestaurantClosedForToday =
      restarantSettingFromRedux?.serviceable[serviceableStrings[ot].string] == 0;
    const isRestaurantClosedForWeek = !serviceTimings[ot]?.order_type_status;
    const serviceableText =
      (isRestaurantClosedForWeek &&
        `${t('restaurant_currently_closed')} ${t(serviceableStrings[ot].type)}`) ||
      (isRestaurantClosedForToday &&
        `${t('opens_text')} ${serviceTimings[ot]?.next_serviceable_day_string} ${t('at')} ${
          serviceTimings[ot]?.next_serviceable_time_string
        }`) ||
      '';

    return {
      isRestaurantClosedForToday,
      isRestaurantClosedForWeek,
      serviceableText,
    };
  };
  const orderTypeDetails = isLoaded && getOrderTypeDetails(+orderType);
  const sessionSetting = getOrderTypeSession();

  const [showTableChangePopUp, setShowTableChangePopUp] = useState(false);
  const [tableObj, setTableObj] = useState({
    oldTableNo: '',
    newTableNo: '',
    newTableId: '',
    dineOrderId: '',
  });
  // Scroll the Page to Top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const showMenuHandler = async () => {
    setShowMenu(true);
    await checkIfShowTableChangePopup();
  };
  const checkIfShowTableChangePopup = async () => {
    const did_scan_qr = getLocalItem('did_scan_qr');
    const historyArr = getSessionItem('history-array')
      ? JSON.parse(getSessionItem('history-array'))
      : [];
    const isStartWithCart =
      (historyArr.length && historyArr[historyArr.length - 1].startsWith('/cart/')) ||
      (historyArr.length > 1 && historyArr[historyArr.length - 2].startsWith('/cart/'));
    if (did_scan_qr === '1') {
      removeLocalItem('did_scan_qr');
    } else if (
      !isStartWithCart &&
      !popUpOpened &&
      restarantSettingFromRedux?.settings?.global?.user_table_change_enabled &&
      getUserToken() &&
      urlQuery &&
      sessionSetting?.orderType == DINEIN_TYPE
    ) {
      const restaurantId = getSessionItem('restaurantId');
      const userCartAndOrders = await getCartForUser(restaurantId);
      const isAlreadyRunningDineInOrderObj = checkIfAlreadyRunningDineInOrder(
        userCartAndOrders,
        restaurantId
      );
      let newTableId = '';
      let newTableNo = '';
      if (urlQuery?.source === 'qr') {
        newTableId = urlQuery?.tableId;
        newTableNo = urlQuery?.tableNo;
      } else {
        newTableId = sessionSetting?.tableNo;
        newTableNo = sessionSetting?.table;
      }

      if (
        isAlreadyRunningDineInOrderObj['showTableChange'] &&
        newTableId !== isAlreadyRunningDineInOrderObj['oldTableId']
      ) {
        setPopUpOpened(true);
        setTableObj({
          oldTableNo: isAlreadyRunningDineInOrderObj['oldTable'],
          newTableNo: newTableNo,
          newTableId: newTableId,
          dineOrderId: isAlreadyRunningDineInOrderObj['dineInOrderId'],
        });
        setShowTableChangePopUp(true);
        return;
      }
    }
  };

  const getCartForUser = async (qr_url_rest_id) => {
    let userCartAndOrders = {};
    const cartTokenFromLS = getCartTokenLS();
    if (cartTokenFromLS) {
      const params = new URLSearchParams();
      params.append('table_id', getTableId());
      params.append('token', getUserToken());
      params.append('restaurant_id', qr_url_rest_id);
      params.append('cart_token', cartTokenFromLS);
      await axiosInstance
        .post(GET_CART, params)
        .then((response) => {
          userCartAndOrders = response?.data?.data?.cart || {};
        })
        .catch((err) => {
          console.error(err.message);
        });
    }
    return userCartAndOrders;
  };

  const closeTableChangePopUp = () => {
    setShowTableChangePopUp(false);
    history.push('/qr');
  };

  const changeTableOnPOS = async () => {
    try {
      const tableChangePayload = {
        order_id: tableObj?.dineOrderId,
        table_id: tableObj?.newTableId,
      };
      await axiosInstanceNext.post(USER_TABLE_CHANGE, tableChangePayload);
    } catch (error) {}
  };

  const tableChangeHandler = async () => {
    setShowTableChangePopUp(false);
    try {
      await changeTableOnPOS();
    } catch (error) {}
  };
  // Adding FbPixel for restaurant
  useEffect(() => {
    const script = document.createElement('script');
    script.textContent = fbPixelScriptText(fbPixelId);
    const noScript = document.createElement('script');
    noScript.textContent = fbPixelNoScriptText(fbPixelId);
    // console.log('fb', noScript);
    document.head.appendChild(script);
    // document.head.appendChild(noScript);
    return () => {
      document.head.removeChild(script);
      // document.head.removeChild(noScript);
    };
  }, [fbPixelId]);

  // Use Effect to fetch Restaurant Settings
  useEffect(() => {
    dispatch(fetchRestSetting(String(urlParams.name)));
  }, []);
  // order type set

  useEffect(() => {
    if (plan === LITE || (plan === LITE_DEL && urlParams?.ot != 2)) {
      history.push('/home');
    }
    restarantIdFromRedux &&
      getPromotions(restarantIdFromRedux).then((response) => {
        setWaitingForPromotions(false);
        if (response.data.statusCode != 200) return;
        if (response?.data?.data?.length) {
          setPromotions(response?.data?.data);
          !hasPromotionShowen && setShowMenu(false);
        }
      });
  }, [restarantIdFromRedux]);

  useEffect(() => {
    setShowMenu((!promotions?.length && !waitingForPromotions) || !!hasPromotionShowen);
  }, [promotions, waitingForPromotions, hasPromotionShowen]);

  useEffect(() => {
    if (!urlParams?.ot && !urlParams.mall) {
      if (restarantSettingFromRedux?.serviceable?.serviceable_order_type) {
        history.replace(
          `/r/${urlParams?.name}/${
            restarantSettingFromRedux?.serviceable?.serviceable_order_type + 1
          }`
        );
      } else if (restarantSettingFromRedux?.serviceable?.serviceable_order_type == DINEIN_TYPE) {
        history.replace(`/r/${urlParams?.name}/2`);
      }
    }
  }, [urlParams, sessionSetting?.orderType, restarantSettingFromRedux]);

  useEffect(() => {
    if (
      !cartTokenFromLSUseEffectDep ||
      cartTokenFromLSUseEffectDep === 'null' ||
      cartTokenFromLSUseEffectDep === 'undefined'
    )
      return;
    if (urlParams.mall || restaurantDetails.loading || !urlParams.ot) return;
    const cartTokenFromLS = getCartTokenLS();
    const orderTypeFromUrl = urlParams.ot;
    const pickupType = urlParams.pickupType;
    const tableId = cookies.tableId || urlQuery.tableId;
    const tableNo = cookies.tableNo || urlQuery.tableNo;
    const restaurantSetting = restaurantDetails?.Setting;
    try {
      const updateOrderTypeInfo = initializeOrderTypeInfo({
        restaurantSetting,
        orderTypeFromUrl,
        pickupType,
        tableId,
        tableNo,
        urlQuery,
        mall: urlParams.mall,
        rest: urlParams?.name,
      });
      if (!updateOrderTypeInfo) return;

      updateCartDetails(
        cartTokenFromLS,
        restaurantDetails?.Setting.id,
        updateOrderTypeInfo?.tableNo,
        updateOrderTypeInfo?.orderType
      );
      dispatch(setOrderType(updateOrderTypeInfo?.orderType));
      orderTypeTrack(
        cartTokenFromLS,
        'Menu Page',
        updateOrderTypeInfo?.orderType,
        '',
        userDetails?.phone,
        '',
        'Initialize order Types',
        url
      );
    } catch (error) {
      console.log(error);
    }
  }, [restaurantDetails?.Setting, urlParams?.ot, cartTokenFromLSUseEffectDep]);

  useEffect(() => {
    if (!restarantSettingFromRedux?.name) return;
    document.title = restarantSettingFromRedux?.name;
    document
      .querySelector('meta[property="og:image"]')
      ?.setAttribute('content', restarantSettingFromRedux?.logo);
    document
      .querySelector('meta[property="og:title"]')
      ?.setAttribute('content', restarantSettingFromRedux?.name);
  }, [restarantSettingFromRedux]);
  // Use Effect to get Cart
  useEffect(() => {
    if (restarantIdFromRedux) setCookie('rest_id', restarantIdFromRedux, { path: '/' });
    // loggedin condition
    if (restarantIdFromRedux && userTokenFromRedux) getCartCallBack();
    // for logged out user
    else if (!userTokenFromRedux && restarantIdFromRedux) getCartFunctionality();
  }, [
    restarantIdFromRedux,
    userTokenFromRedux,
    orderTypeAndTime.orderType,
    orderTypeAndTime.orderTime,
    orderTypeAndTime.epoch,
  ]);

  const getAddMoreOrderRunningStatus = (orders) => {
    return orders?.find(
      (order) => order.order_id === JSON.parse(getSessionItem('add_more'))?.order_id
    );
  };

  useEffect(() => {
    // If add more order is complete delete it from session storage
    const isAddMoreOrderRunning = getAddMoreOrderRunningStatus(cartFromRedux?.order);
    if (
      !isAddMoreOrderRunning &&
      cartFromRedux?.order !== undefined &&
      cartLoadedFromRedux &&
      cartDispatchCount > 1
    ) {
      removeSessionItem('add_more');
    }
  }, [cartFromRedux, restarantIdFromRedux, cartLoadedFromRedux]);

  useEffect(() => {
    if (cartLoadedFromRedux === true) setCartDispatchCount((prev) => prev + 1);
  }, [cartLoadedFromRedux]);

  // Setting running orders to set Red Banner in Footer
  useEffect(() => {
    const cartTokenFromLS = getCartTokenLS();
    if (cartFromRedux?.current_restaurant_id === restarantIdFromRedux) {
      setPreviousOrders(cartFromRedux?.order);
    }
    // checking if cart created is for same opened Restaurant
    if (
      restarantIdFromRedux &&
      cartFromRedux?.current_restaurant_id &&
      cartFromRedux?.current_restaurant_id !== restarantIdFromRedux &&
      cartTokenFromLS
    ) {
      const cartToken = setCheckCartToken('');
      cookiesCartTokenTrack({
        fileName: 'menu.js',
        functionName: 'useEffect: 1',
        cartToken: cartToken || cartToken + '',
      });
      // setCookie('cart_token', cartToken, { path: '/' });
      setLocalItem('cart_token', cartToken);
      getCartCallBack();
    }
  }, [cartFromRedux, restarantIdFromRedux]);
  // Updating Discount coupons
  useEffect(() => {
    updateDiscountCoupon();
  }, [cartBillFromRedux]);
  // To Add Title of Document
  useEffect(() => {
    if (urlQuery.source === 'qr' && sessionSetting?.orderType != DINEIN_TYPE) {
      setOrderTypeSession({
        orderType: DINEIN_TYPE,
        tableNo: cookies.tableId || urlQuery.tableId,
        table: cookies.tableNo || urlQuery.tableNo,
      });
      dispatch(setOrderType(DINEIN_TYPE));
    }
  }, []);

  // Set table id and table no in cookies and session storage if qr source is found in url i.e dine in
  useEffect(() => {
    if (
      urlQuery?.source === 'qr' &&
      urlQuery?.tableId &&
      urlQuery?.tableNo &&
      urlQuery?.tableId !== sessionSetting?.tableNo &&
      urlQuery?.tableNo !== sessionSetting?.table
    ) {
      setCookie('tableId', urlQuery?.tableId, { path: '/' });
      setCookie('tableNo', urlQuery?.tableNo, { path: '/' });
      setOrderTypeSession({
        orderType: DINEIN_TYPE,
        tableNo: urlQuery?.tableId,
        table: urlQuery?.tableNo,
      });
      setOrderSessionTrack({
        fileName: 'menu.js',
        functionName: 'useEffect',
        orderType: DINEIN_TYPE,
        tableId: urlQuery?.tableId,
        tableNo: urlQuery?.tableNo,
      });
      setCookieTableInfoTrack({
        fileName: 'menu.js',
        functionName: 'useEffect',
        tableId: urlQuery?.tableId + '',
        tableNo: urlQuery?.tableNo + '',
      });
    }
    (async () => {
      await checkIfShowTableChangePopup();
    })();
  }, [urlQuery]);

  useEffect(() => {
    if (countryCode != 'id') {
      (async () => {
        const permissionStatus = await navigator.permissions.query({
          name: 'geolocation',
        });
        if (permissionStatus.state != 'granted') {
          window.addEventListener('scroll', () => {
            setShowPopup(true);
          });
        }
      })();
    }

    return window.removeEventListener('scroll', () => {});
  }, []);

  useEffect(() => {
    setBackPath(MENU, url);
    setBackPage(url);
    setMenuPath(
      `${history.location.pathname}${
        urlQuery.orderTime !== SCHEDULED ? history.location.search : ''
      }`
    );
    setHistoryArray(history.location.pathname + history.location.search);
    setLocalItem('otpLess', history.location.pathname + history.location.search);
  }, [url]);

  // Function
  useEffect(() => {
    restarantSettingFromRedux?.id &&
      menuTrack(
        restarantSettingFromRedux.id,
        sessionSetting?.orderTime,
        userDetails?.phone,
        sessionSetting?.orderType
      );
  }, [restarantSettingFromRedux?.id]);

  const openQrScanner = () => {
    urlParams.mall && setRoute('/qr');
    history.push('/qr');
  };

  const getCart = () => {
    const cartTokenFromLS = getCartTokenLS();
    const cartToken = setCheckCartToken(cartTokenFromLS);
    cookiesCartTokenTrack({
      fileName: 'menu.js',
      functionName: 'getCart',
      cartToken: cartToken || cartToken + '',
    });
    // setCookie('cart_token', cartToken, { path: '/' });
    dispatch(getCartFunction(cartToken, restarantIdFromRedux));
  };

  const updateDiscountCoupon = () => {
    if (coupon == cartBillFromRedux?.coupon?.coupon_id) return;

    setCoupon(cartBillFromRedux?.coupon?.coupon_id);
    setcouponCode(cartBillFromRedux?.coupon?.coupon_name);

    const couponValue = urlParams?.name?.toLowerCase() + cartBillFromRedux?.coupon?.coupon_id;
    if (cartBillFromRedux?.coupon?.coupon_id === undefined || cookies.coupon == couponValue) return; //check if the coupon id exist

    setCookie('coupon', couponValue, { path: '/' });
    setCouponApplied(true);
  };

  const getCartCallBack = () => {
    if (restarantIdFromRedux && userTokenFromRedux && getUserToken()) {
      getCartFunctionality();
    }
  };
  const getCartFunctionality = () => {
    const cartTokenFromLS = getCartTokenLS();
    getCart();
    if (cartTokenFromLS) {
      dispatch(getCartBillFunction('', cartTokenFromLS, restarantIdFromRedux, [], 'easyeat'));
    }
    setCookie('user_token', userTokenFromRedux, { path: '/' });
  };
  const showOrderType = urlParams.mall || getRestaurantType() != 1;
  const globalSetting = restarantSettingFromRedux?.settings?.global;

  const orderTypeFromRedux = useSelector((state) => state.orderTypeOrderTime?.orderType);
  const shouldShowLoyalty = isLoyaltyShowing(orderTypeFromRedux, restarantSettingFromRedux);
  const { setLoading } = useContext(GlobalContext);

  const loyaltyOrderTypes = useSelector(
    (state) => state.restSetting?.Setting?.loyalty_settings_v2?.order_types
  );
  const showMinLoyaltyForCurrentOrderType = loyaltyOrderTypes?.includes(
    validateLoyaltyOrderTypes[orderType]
  );

  useEffect(() => {
    setSessionItem('restaurantId', restarantIdFromRedux);
    setSessionItem(
      'show_recommendations',
      plan === PRO && (globalSetting?.show_recommendations || 0)
    );
  }, [restarantIdFromRedux]);

  // Back Button Navigation
  window.addEventListener('popstate', () => {
    if (history?.location?.state?.length === 2) {
      setShowExitPagePopup(true);
    } else {
      setShowExitPagePopup(false);
    }
  });

  const exitPageYesHandler = () => {
    setShowExitPagePopup(false);
    history.goBack();
  };

  const exitPageNoHandler = () => {
    setShowExitPagePopup(false);
    history.goForward();
  };

  useEffect(() => {
    if (
      !getSessionItem('scanThroughQr') &&
      (urlQuery?.source === 'qr' || !historyArray.some((arr) => arr.includes('home')))
    ) {
      setSessionItem('scanThroughQr', true);
    }
  }, [urlQuery, historyArray]);

  useEffect(() => {
    if (
      urlParams?.ot &&
      history.length === 2 &&
      !urlQuery?.page &&
      historyArray.every((arr) => arr.includes('/r/'))
    ) {
      history.replace({
        pathname: history.location.pathname,
        search: history.location.search
          ? `${history.location.search}&page=${history.length}`
          : `?page=${history.length}`,
        state: { length: history.length },
      });
    }
    if (
      urlParams?.ot &&
      history.length === 2 &&
      urlQuery?.page == 2 &&
      !historyArray.some((arr) => arr.includes('home'))
    ) {
      history.push({
        pathname: history.location.pathname,
        search: history.location.search,
        state: { length: history.length + 1 },
      });
    }
  }, [history.length, urlQuery]);

  useEffect(() => {
    if (userId && restarantIdFromRedux) {
      fetchReferrerCode(restarantIdFromRedux).then((res) => setReferrerCode(res));
    }
  }, [userId, restarantIdFromRedux]);

  useEffect(() => {
    if (restarantIdFromRedux) {
      fetchReferralInfo(restarantIdFromRedux).then((res) => setReferralInfo(res));
    }
  }, [restarantIdFromRedux]);

  // Global loading
  useEffect(() => {
    setLoading(false);
    if (getSessionItem('whatsapp_otpless_url') == '/login') {
      setLocalItem('sendToCart', 1);
      removeSessionItem('whatsapp_otpless_url');
    }
  }, []);

  if (waitingForPromotions || (isNaN(urlParams.ot) && !urlParams.mall)) {
    return <AppLoader />;
  }

  if (!isLoaded) return <Skeleton page='menu' />;

  return (
    <>
      {!showMenu && !hasPromotionShowen && !!promotions?.length && (
        <Promotion promotions={promotions} showMenuHandler={showMenuHandler} />
      )}

      {showMenu && (
        <MenuCategoryContext.Provider
          value={{
            categoryId,
            setCategoryId,
            eventType,
            setEventType,
            shouldShowLoyalty,
            referrerCode,
            referralInfo,
          }}>
          {urlParams.mall ? (
            <FCHeader name={restarantSettingFromRedux.name} logo={restarantSettingFromRedux.logo} />
          ) : (
            <NormalRestaurantHead
              nameId={urlParams.name}
              name={restarantSettingFromRedux.name}
              imageUrl={restarantSettingFromRedux.logo}
              location={restarantSettingFromRedux.city}
              serviceableText={orderTypeDetails?.serviceableText}
              loggedIn={(userTokenFromRedux?.length && 1) || 0}
              setDrawer={() => setDrawer(true)}
              setShowChangeLanguage={setShowChangeLanguage}
              restaurantRating={restarantSettingFromRedux?.avg_rating}
              restaurantAddress={restarantSettingFromRedux?.address}
              cuisine={restarantSettingFromRedux?.cuisine}
            />
          )}

          {!urlParams.mall && (
            <div
              className={`dotted-line mx-20px ${
                !restarantSettingFromRedux?.menu_cover_img ? 'mt-2' : ''
              }`}
            />
          )}

          {!urlParams?.mall && (
            <>
              {showOrderType && (
                <OrderType
                  openQrScanner={openQrScanner}
                  isRestaurantClosed={orderTypeDetails?.isRestaurantClosedForToday}
                  isPreorderAvailable={
                    !orderTypeDetails?.isRestaurantClosedForWeek &&
                    orderTypeDetails?.isRestaurantClosedForToday
                  }
                  restaurantId={restarantIdFromRedux}
                  showOrderTypePopup={showOrderTypePopup}
                  setShowOrderTypePopup={setShowOrderTypePopup}
                  plan={plan}
                />
              )}
              {!orderTypeDetails?.isRestaurantClosedForWeek && (
                <Discount
                  showMinLoyaltyForCurrentOrderType={showMinLoyaltyForCurrentOrderType}
                  setFreeDeliveryCoupon={setFreeDeliveryCoupon}
                />
              )}
            </>
          )}

          {/* When restaurant is closed for any ordertype, current day and next serviceable days */}
          {orderTypeDetails?.isRestaurantClosedForWeek && <RestaurantClosed />}

          {/* When restaurant is open for any ordertype and current day and next serviceable days */}
          {!orderTypeDetails?.isRestaurantClosedForWeek &&
            restarantSettingFromRedux?.id &&
            restarantSettingFromRedux?.nameid.toLowerCase() === urlParams.name.toLowerCase() && (
              <MenuItems restId={restarantSettingFromRedux?.id} />
            )}

          {couponApplied && (
            <SuspenseWrapper>
              <DiscountAppliedPopUp close={() => setCouponApplied(false)} couponCode={couponCode} />
            </SuspenseWrapper>
          )}
          <Footer
            fc={!!urlParams.mall}
            previousOrders={previousOrders}
            setShowOrderTypePopup={setShowOrderTypePopup}
            getCart={getCart}
            freeDeliveryCoupon={freeDeliveryCoupon}
            restaurantId={restarantSettingFromRedux?.id}
            restaurantName={restarantSettingFromRedux?.name}
            showMinLoyaltyForCurrentOrderType={showMinLoyaltyForCurrentOrderType}
          />

          {drawer && (
            <SuspenseWrapper>
              <QuickServicesPopup
                drawer={drawer}
                setDrawer={setDrawer}
                restaurantId={restarantSettingFromRedux?.id}
              />
            </SuspenseWrapper>
          )}
          {showChangeLanguage && (
            <SuspenseWrapper>
              <ChangeLanguagePopup close={() => setShowChangeLanguage(false)} />
            </SuspenseWrapper>
          )}
        </MenuCategoryContext.Provider>
      )}
      {showExitPagePopup && (
        <SuspenseWrapper>
          <ExitPagePopup
            exitPageYesHandler={exitPageYesHandler}
            exitPageNoHandler={exitPageNoHandler}
          />
        </SuspenseWrapper>
      )}
      {showPopup && orderType == DELIVERY_TYPE && <LocationPopupImporter />}
      {showTableChangePopUp && (
        <SuspenseWrapper>
          <TableChangePopUp
            open={true}
            close={closeTableChangePopUp}
            tableChangeHandler={tableChangeHandler}
            oldTableNo={tableObj?.oldTableNo}
            newTableNo={tableObj?.newTableNo}
          />
        </SuspenseWrapper>
      )}
    </>
  );
}

export default Menu;
export { MenuCategoryContext };
